/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.14",
    versionName: "0.2.0-nightly.2026.2.14",
    versionChannel: "nightly",
    buildDate: "2026-02-14T00:11:08.158Z",
    commitHash: "b4a3f18f71e18fc1817fab2fd5c9a63b8a8fcf08",
};
